import { InjectionToken } from '@angular/core';

export const UNAUTHORIZED_REDIRECT_ROUTE = new InjectionToken<string | undefined>('UnauthorizedRedirectRoute');
